import { BrowserRouter as Router } from 'react-router-dom';
import RootRoute from './routes/RootRoute';
import './App.scss';

function App() {
  return (
    <Router>
      <RootRoute/>
    </Router>
  );
}

export default App;
